import { createApp, provide, h, markRaw } from 'vue';
import App from './App.vue';

import '@/assets/styles/fonts.scss';
import '@/assets/styles/main.css';

import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import * as Sentry from '@sentry/vue';
import { Quasar, Notify, Dialog, EventBus } from 'quasar';
import messages from '@intlify/unplugin-vue-i18n/messages';
import { DefaultApolloClient } from '@vue/apollo-composable';

import '@quasar/extras/material-icons/material-icons.css';

// Import Quasar css
import 'quasar/src/css/index.sass';

import router from './routes/router';
import { apolloClient } from '@/apollo';
import { config } from '@/config';

const pinia = createPinia();
pinia.use(({ store }) => {
  store.router = markRaw(router);
});

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'en',
  fallbackLocale: 'de',
  messages,
});

const bus = new EventBus();

const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient);
  },
  render: () => h(App),
});

app.provide('bus', bus);

if (config.sentry && config.sentry.dsn) {
  Sentry.init({
    app,
    dsn: config.sentry.dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
    tracePropagationTargets: [config.apiURI],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

app.use(pinia);
app.use(i18n);
app.use(Quasar, {
  plugins: {
    Notify,
    Dialog,
  },
});
app.use(router);

app.mount('#app');
